// extracted by mini-css-extract-plugin
export var alertIcon = "_tk-0";